import { toMoneyWithTwoDecimalDigits } from "utils/currency";
import "./index.scss";

export const StatusArea = ({ totalPrice, savings }) => {
  return (
    <div className="status-area">
      <div className="subtotal">
        <div className="row">
          Subtotal{""}
          <strong>{toMoneyWithTwoDecimalDigits(totalPrice)}</strong>
        </div>
        <div className="bottom-row">
          Your Savings{""}
          <span>{toMoneyWithTwoDecimalDigits(savings)}</span>
        </div>
      </div>
    </div>
  );
};
